// Seleccionamos todos los fields (donde estan contenidos los spans)
function variantPicker() {
  const fields = document.querySelectorAll(".variant-card-picker");

  fields.forEach((field) => {
    // Seleccionamos los spans de cada field
    const variants = field.querySelectorAll("div");

    variants.forEach((option) => {
      //A cada span (variante) le agregamos un evento onClick
      option.addEventListener("click", () => {
        //Como tenemos un div en mobile y otro en laptop, seleccionamos ambos con la clase card-_____.
        const cards = document.querySelectorAll(`.card-${field.id}`);

        // Get the price values and ensure they're numbers
        const price = parseFloat(option.dataset.price.replace('$', ''), 10);
        const comparePrice = parseFloat(option.dataset.comparePrice.replace('$', ''), 10);
        const newImg = option.dataset.variantImageUrl;
        const formattedPrice = option.dataset.variantPrice;

        console.log('Parsed price:', price);
        console.log('Parsed comparePrice:', comparePrice);

        console.log(cards);

        // A cada card le asignamos el nuevo img y price.e
        cards.forEach((card) => {
          const productImg = card.querySelector("img");
          const productPrice = card.querySelector("span");
          const discountTag = card.querySelector('[id^="discount-"]');

          // Update image and price
          productImg.src = newImg;
          productPrice.innerText = formattedPrice;


          // Calculate and update discount
          if (comparePrice && comparePrice > price) {
            const discountPercentage = ((comparePrice - price) / comparePrice) * 100;
            if (discountTag) {
              discountTag.innerText = `${Math.round(discountPercentage)}%`;
              discountTag.style.display = 'block';
              card.dataset.productDiscount = discountPercentage;
            }
          } else {
            if (discountTag) {
              discountTag.style.display = 'none';
              card.dataset.productDiscount = '';
            }
          }
        });
      });
    });
  });
}

//Este evento se disparará cuando se cambie una variante
document.addEventListener("updateVariantPicker", () => {
  variantPicker();
});

//Ejecutamos la función por defecto
variantPicker();
